import { User } from './../../../../../types/tournament';

export const getPlayerName = ({firstName, lastName}: User) => (`${firstName || ''} ${lastName || ''}`.trim())